import soundManager from "slotworks/sound/sound-manager";
import RevolverBigWins from "slotworks/integration/revolver/states/revolver-big-wins";
import gameState from "slotworks/model/game-state";
import Components from "slotworks/components/components";
import betModel from "slotworks/model/bets/bet-model";
import G288SpinRecord from "integration/spin-record";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import State from "slotworks/state-machine/states/state";
import Layers from "slotworks/graphics/layers/layers";
import G288Components from "components/components";
import { RestoreSymbolsCommand } from "commands/symbols-commands";
import { StaticSymbolsCommand } from "slotworks/commands/symbols/static-symbols-command";

export default class G288BigWins extends State {
    
    private onComplete: Function;
    private isBigWin: boolean = false;

    public onEnter(cascadeSkip: boolean) {
        const record = gameState.getCurrentGame().getCurrentRecord() as G288SpinRecord;
        if(!gameState.getCurrentGame().inFreespinsGame && 
                G288Components.bigWin.isBigWin(record.creditsWon, betModel.getTotalBet())
                && (!record.freespinsTriggered || record.stackAddFeatureTriggered || record.beenPaid)) {
        //    soundManager.customEvent("pre_win");
            this.isBigWin = true;
        //    setTimeout(() => super.onEnter(cascadeSkip), 2000);
        } else {
            this.isBigWin = false;
            
        }
        this.start(cascadeSkip);
    }

    public onExit() {
        if(this.isBigWin) {
            soundManager.customEvent("base_music");
            RestoreSymbolsCommand(Components.matrix.getAllSymbols());
            StaticSymbolsCommand().execute();
        }
    }

    public onSkip(cascaded: boolean) {
        if (cascaded) {
            this.skip();
        } else {
            this.onComplete = () =>  this.skip();
        }
    }

    public complete() {
        const record = gameState.getCurrentGame().getCurrentRecord();
        const winnings = gameState.getCurrentGame().totalCreditsWon;

        if (record.beenPaid && G288Components.bigWin.isBigWin(winnings, betModel.getTotalBet())) {
            Components.betBar.winnings.setWinnings(0, winnings, 750);
        }

        super.complete();
    }

    private start(cascadeSkip: boolean) {
        if (!cascadeSkip) {
            this.onComplete = () => this.complete();

            const wasPromoVisible = Layers.PromoBetBar.container.visible;

            this.run().then((bigWin) => {
                if(wasPromoVisible && bigWin && campaignsModel.isFreespinsActive()) {
                    Layers.PromoBetBar.show();
                    Layers.SmartButton.show();
                }
                if (this.onComplete) {
                    this.onComplete();

                }
            });
        }

        const freespins = campaignsModel.freespins;
        if(freespins) {
            try {
                Components.promoBetBar.setTotalWin(freespins.totalWin);
            }catch(e) {

            }
        }
    }

    private run() {
        let winnings;
        if (gameState.getCurrentGame().getCurrentRecord().beenPaid) {
            winnings = gameState.getCurrentGame().totalCreditsWon;
        } else {
            winnings = gameState.getCurrentGame().getCurrentRecord().creditsWon;
        }
        const stake = betModel.getTotalBet();

        return G288Components.bigWin.showWin(winnings, stake);
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/big-wins.ts